export * from './mapChartsConfigToLatestVersion';
